import { PasswordControlInterface } from '../components/password-input/interfaces';

import { BaseControl } from './base-control';

export class PasswordControl extends BaseControl {
  public hintDisabled: boolean;

  constructor(data: PasswordControlInterface) {
    super(data);

    this.hintDisabled = data.hintDisabled;
  }
}
